var script = {
  name: 'CalendarMonth',
  props: {
    month: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isHovering: false
    };
  },
  methods: {
    handleMonthClick() {
      if (this.month.disabled) {
        return;
      }
      this.$emit('click', this.month.key);
    },
    handleMonthMouseEnter() {
      if (this.month.disabled) {
        return;
      }
      this.isHovering = true;
    },
    handleMonthMouseLeave() {
      this.isHovering = false;
    }
  }
};

export { script as default };
//# sourceMappingURL=calendar-month.vue2.js.map
